// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__KwRSs","header":"PatientBlock_header__1l-67","label":"PatientBlock_label__11l54","option":"PatientBlock_option__SvXxC"};